module.exports = "/static/images/menu-contact.jpg";